import { AngularFireAuth } from '@angular/fire/auth';
import { Component, OnInit, EventEmitter, Output, ViewChild, ElementRef, AfterViewInit } from "@angular/core";

export interface LoginFormComponentData { email: string; password: string; isNew?: boolean; }

@Component({
  selector: "app-login-form",
  templateUrl: "./login-form.component.html",
  styleUrls: ["./login-form.component.css"]
})
export class LoginFormComponent implements OnInit, AfterViewInit {
  @Output() submitted = new EventEmitter<LoginFormComponentData>();
  email: string;
  password: string;

  emailValid: boolean = null;
  willingToCreateNewAccount: boolean = null;

  @ViewChild("emailInput") emailInput: ElementRef;

  constructor(private afAuth: AngularFireAuth) { }

  ngOnInit() { }

  ngAfterViewInit() {
    this.emailInput.nativeElement.focus();
  }

  onSubmit() {
    if (this.emailValid) {
      this.submitted.emit({ email: this.email, password: this.password, isNew: this.willingToCreateNewAccount });
    } else {
      this.validateEmail();
    }
  }

  async validateEmail() {
    try {
      const providers = await this.afAuth.fetchSignInMethodsForEmail(this.email);
      if (providers.indexOf("password") >= 0) {
        this.emailValid = true;
      } else if (providers.length === 0) {

        // new account OR existing account without password
        try {
          await this.afAuth.sendPasswordResetEmail(this.email);
          alert("Poichè sei già nostro cliente, ti abbiamo inviato una email all'indirizzo " + this.email + " con un link grazie al quale potrai impostare la tua password ed accedere a My QuoVado. Segui le istruzioni riportate nella email.");
          // TODO: impedire di inviare troppe volte la mail...
        } catch (error) {
          if (error.code === "auth/user-not-found") {
            if (confirm("Non hai ancora un account con questa email. Vuoi creare ora un nuovo account?")) {
              this.willingToCreateNewAccount = true;
              this.emailValid = true;
            }
          } else {
            alert(error);
          }
        }

      } else {
        alert("Hai già effettuato l'accesso in precedenza con " + providers[0] + ", utilizza questo metodo per accedere.");
      }
    } catch (error) {
      alert(error);
    }
  }

  async resetPassword() {
    try {
      await this.afAuth.sendPasswordResetEmail(this.email);
      alert("Abbiamo inviato una email per il recupero della tua password all'indirizzo " + this.email + ". Segui le istruzioni riportate nella email.");
    } catch (error) {
      alert(error);
    }
  }

}
